import NProgress from 'nprogress';
import { toast } from 'react-toastify';
import axiosInstance from '../../../../../axiosInstance';
import { HRMS_LMS_API_URL } from '../../../../Constants/baseConstant';
import { getUserData, getUserId } from '../../../Base/helper/baseFunctions';

export const TimeOffHelper = async (params) => {
    var user = getUserData();
    NProgress.start()
    return await axiosInstance(`/lms/getTimeOff`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            workspace: user.domain,
            employee_fk: user?.employee_id || null,
            month_year: params?.month_year || null,
            emp_user_id: params?.my_time_flag ? null : getUserId(),
            approval_screen: params?.approval_screen || false
        }
    })
        .then((res) => {
            NProgress.done()
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const TimeOffBookingsHelper = async (report) => {
    var data = getUserData();
    toast.info("Loading...")
    return await axiosInstance(`/lms/getTimeOffBooking`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            emp_id: report?.emp_id || null,
            leavetype_id: +(report?.leavetype_id?.leavetype_id) || 0,
            status: report?.status?.name || null,
            emp_user_id: report?.emp_user_id || null,
        }
    })
        .then((res) => {
            toast.dismiss();
            res?.data?.data?.length === 0 && toast.warning("No Records Found")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const TeamTimeOffHelper = async (params) => {
    var user = getUserData();
    NProgress.start()
    return await axiosInstance(`/lms/getTeamTimeOff`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            workspace: user.domain,
            emp_user_id: getUserId(),
            month_year: params?.month_year
        }
    })
        .then((res) => {
            NProgress.done()
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const ReportingEmployeeHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/lms/getReportingEmployee`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: params?.domain ||  data?.domain,
            reporting_manager_id: params?.reporting_manager_id || data.employee_id,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetTeamBalanceHelper = async (report) => {
    var data = getUserData();
    return await axiosInstance(`/lms/getTeamBalance`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            emp_user_id: getUserId(),
            ats_work_location_json: report?.ats_work_location_json || null,
            user_id: getUserId()
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}


export const UpdateTeamBalanceHelper = async (report) => {
    var data = getUserData();
    toast.info("Updating...")
    return await axiosInstance(`/lms/updateTeamBalance`, {
        method: "PUT",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            reporting_manager_id: data.employee_id,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Updated")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

